<template>
	<vs-chip
		v-if="status === 'FINALIZED' || status === 'ERROR' || status === 'CREATED'"
		class="ag-grid-cell-chip"
		:color="chipColor(status)"
	>
		<vx-tooltip
			:text="
				status === 'FINALIZED'
					? $t('Routing.RoutingHistory.SuccessRoutingProcess')
					: $t('Routing.RoutingHistory.ErrorRoutingProcess')
			"
			position="bottom"
			class="flex items-center"
		>
			<i class="material-icons mr-1">{{ status === "FINALIZED" ? "check_circle" : "error" }}</i>
			<span class="uppercase">{{
				status === "FINALIZED" ? $t("Routing.ROUTING_DONE") : $t("Routing.ROUTING_ERROR")
			}}</span>
		</vx-tooltip>
	</vs-chip>
	<div v-else>
		<vx-tooltip :text="$t('Routing.Messages.AlertProccessing')" position="bottom" delay=".1s">
			<vs-progress
				:height="8"
				:indeterminate="loading"
				:percent="percent"
				:color="chipColor(status)"
			></vs-progress>
		</vx-tooltip>
	</div>
</template>

<script>
export default {
	name: "CellRendererStatus",
	data() {
		return {
			percent: 0,
			loading: true,
			status: "",
		};
	},
	beforeMount() {
		this.updateStatus();
	},
	computed: {
		chipColor() {
			return (value) => {
				if (value === "FINALIZED") {
					this.percent = 100;
					this.loading = false;
					return "success";
				}
				if (value === "ERROR" || value === "CREATED") {
					this.percent = 100;
					this.loading = false;
					return "danger";
				} else if (value === "PROCESSING") {
					this.loading = true;
					return "primary";
				} else return "secondary";
			};
		},
	},
	methods: {
		updateStatus() {
			this.status = this.params.value;
		},
	},
};
</script>

<style lang="scss" scoped>
.ag-grid-cell-chip {
	&.vs-chip-success {
		background: rgba(var(--vs-success), 0.15);
		color: rgba(var(--vs-success), 1) !important;
		font-weight: 500;
	}
	&.vs-chip-warning {
		background: rgba(var(--vs-warning), 0.15);
		color: rgba(var(--vs-warning), 1) !important;
		font-weight: 500;
	}
	&.vs-chip-danger {
		background: rgba(var(--vs-danger), 0.15);
		color: rgba(var(--vs-danger), 1) !important;
		font-weight: 500;
	}
}
.material-icons {
	font-size: 1.7em;
}
</style>
